function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "System-Admin",
  transform: "translate(-819.000000, -417.000000)",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "noun_right_899042",
  transform: "translate(800.000000, 417.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M26.5897436,1.17866501e-12 C22.5011616,1.17866501e-12 19.1794872,3.32413483 19.1794872,7.41573371 C19.1794872,11.5073292 22.5011616,14.831464 26.5897436,14.831464 C30.6783256,14.831464 34,11.5073292 34,7.41573371 C34,3.32413483 30.6783256,1.17866501e-12 26.5897436,1.17866501e-12 L26.5897436,1.17866501e-12 Z M26.5897436,0.674157303 C30.314253,0.674157303 33.3263403,3.68846629 33.3263403,7.41573371 C33.3263403,11.1429978 30.314253,14.1573067 26.5897436,14.1573067 C22.8652342,14.1573067 19.8531469,11.1429978 19.8531469,7.41573371 C19.8531469,3.68846629 22.8652342,0.674157303 26.5897436,0.674157303 L26.5897436,0.674157303 Z M27.7265443,5.2247191 C27.5967406,5.24244277 27.4890426,5.3341572 27.4506187,5.45969411 C27.4121949,5.58523102 27.4500496,5.72170653 27.5476034,5.80934831 L28.9265006,7.07865506 L23.405649,7.07865506 C23.3951289,7.07815909 23.3845914,7.07815909 23.3740712,7.07865506 C23.2539242,7.08430311 23.1459107,7.15377354 23.0907207,7.26089589 C23.0355308,7.36801825 23.0415497,7.49651692 23.1065101,7.59798474 C23.1714705,7.69945256 23.2855026,7.75847303 23.405649,7.75281236 L28.9265006,7.75281236 L27.5476034,9.0168573 C27.4584193,9.09789676 27.4191456,9.2204743 27.4445783,9.33841065 C27.4700109,9.456347 27.5562854,9.55172227 27.6708992,9.58860522 C27.785513,9.62548817 27.9110509,9.59827461 28.0002185,9.51721685 L30.0159346,7.66328427 C30.0866101,7.59940815 30.1269552,7.50849229 30.1269552,7.41310449 C30.1269552,7.3177167 30.0866101,7.22680084 30.0159346,7.16292472 L28.0002185,5.31424719 C27.9346208,5.25330082 27.8474912,5.22108001 27.7581221,5.2247191 C27.747602,5.22422313 27.7370644,5.22422313 27.7265443,5.2247191 Z",
  id: "Shape"
})))));

var SvgRightArrowCircle = function SvgRightArrowCircle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRightArrowCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-arrow-circle.60ad2f02.svg";
export { ForwardRef as ReactComponent };